export const post_message = {
    methods: {
        postFlutterMessage(name){
                if (!this.webview || !window.flutter_inappwebview) return;

                const message = JSON.stringify({
                    type: 'true',
                    actionType: name,
                });

                try {
                    window.flutter_inappwebview.postMessage(message);
                } catch {
                    window.flutter_inappwebview.callHandler('postMessage', message);
                }
            }
    }
};
